(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/objectWithoutProperties", "@babel/runtime/helpers/classCallCheck", "@babel/runtime/helpers/createClass", "@babel/runtime/helpers/possibleConstructorReturn", "@babel/runtime/helpers/getPrototypeOf", "@babel/runtime/helpers/inherits", "@babel/runtime/helpers/defineProperty", "react", "prop-types", "../../context"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/objectWithoutProperties"), require("@babel/runtime/helpers/classCallCheck"), require("@babel/runtime/helpers/createClass"), require("@babel/runtime/helpers/possibleConstructorReturn"), require("@babel/runtime/helpers/getPrototypeOf"), require("@babel/runtime/helpers/inherits"), require("@babel/runtime/helpers/defineProperty"), require("react"), require("prop-types"), require("../../context"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.objectWithoutProperties, global.classCallCheck, global.createClass, global.possibleConstructorReturn, global.getPrototypeOf, global.inherits, global.defineProperty, global.react, global.propTypes, global.context);
    global.unknown = mod.exports;
  }
})(this, function (_exports, _objectWithoutProperties2, _classCallCheck2, _createClass2, _possibleConstructorReturn2, _getPrototypeOf2, _inherits2, _defineProperty2, _react, _propTypes, _context) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _objectWithoutProperties2 = _interopRequireDefault(_objectWithoutProperties2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);

  var noop = function noop() {};

  var DataGrid =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2.default)(DataGrid, _React$Component);

    function DataGrid(props, context) {
      var _this;

      (0, _classCallCheck2.default)(this, DataGrid);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DataGrid).call(this, props, context));

      var _ref = props || {},
          propsCore = _ref.core,
          others = (0, _objectWithoutProperties2.default)(_ref, ["core"]);

      var core = propsCore || (0, _context.getGridCore)(others);
      _this.state = {
        core: core
      };
      return _this;
    }

    (0, _createClass2.default)(DataGrid, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var onMount = this.props.onMount;
        var core = this.state.core;
        core.launch(); // 由UI通知核心正式开始运行

        onMount(core);
      }
    }, {
      key: "render",
      value: function render() {
        var children = this.props.children;
        return _react.default.createElement(_context.Provider, {
          value: this.state
        }, children);
      }
    }]);
    return DataGrid;
  }(_react.default.Component);

  _exports.default = DataGrid;
  (0, _defineProperty2.default)(DataGrid, "propTypes", {
    onMount: _propTypes.default.func,
    children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.array]),
    dataSource: _propTypes.default.array,
    url: _propTypes.default.string,
    params: _propTypes.default.object,
    defaultPage: _propTypes.default.number,
    pageSize: _propTypes.default.number,
    defaultFilterValues: _propTypes.default.object,
    query: _propTypes.default.func,
    autoLoad: _propTypes.default.bool,
    formatBefore: _propTypes.default.func,
    formatAfter: _propTypes.default.func,
    formatFilter: _propTypes.default.func
  });
  (0, _defineProperty2.default)(DataGrid, "defaultProps", {
    dataSource: [],
    pageSize: 10,
    defaultPage: 0,
    autoLoad: true,
    onMount: noop
  });
});